"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description: 获取要过期的storage，基于uni.getStorageSync
 * @param {key} 键值
 * @return {value} storage值
 */
function getExpireStorage(key) {
    var value = JSON.parse(window.localStorage.getItem(key) || '{}');
    var expires = value.expires, startTime = value.startTime;
    if (expires && startTime) {
        var now = new Date().getTime();
        if (now - startTime > expires) {
            window.localStorage.removeItem(key);
            return null;
        }
        else {
            return value;
        }
    }
    else {
        return null;
    }
}
exports.default = getExpireStorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWV4cGlyZS1zdG9yYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL2dldC1leHBpcmUtc3RvcmFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBOzs7O0dBSUc7QUFDSCxTQUF3QixnQkFBZ0IsQ0FBRSxHQUFXO0lBQ25ELElBQUksS0FBSyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLElBQUksSUFBSSxDQUFDLENBQUE7SUFDMUQsSUFBQSxPQUFPLEdBQWdCLEtBQUssUUFBckIsRUFBRSxTQUFTLEdBQUssS0FBSyxVQUFWLENBQVU7SUFDbEMsSUFBSSxPQUFPLElBQUksU0FBUyxFQUFFO1FBQ3hCLElBQUksR0FBRyxHQUFHLElBQUksSUFBSSxFQUFFLENBQUMsT0FBTyxFQUFFLENBQUE7UUFDOUIsSUFBSSxHQUFHLEdBQUcsU0FBUyxHQUFHLE9BQU8sRUFBRTtZQUM3QixNQUFNLENBQUMsWUFBWSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FBQTtZQUNuQyxPQUFPLElBQUksQ0FBQTtTQUNaO2FBQU07WUFDTCxPQUFPLEtBQUssQ0FBQTtTQUNiO0tBQ0Y7U0FBTTtRQUNMLE9BQU8sSUFBSSxDQUFBO0tBQ1o7QUFDSCxDQUFDO0FBZEQsbUNBY0MifQ==